import type { BufferingMode } from '../enums';
import { TimeAwareBase } from './TimeAwareBase';

/**
 * An implementation of Base for objects which don't change with time. It defines no-ops for
 * time related operations (like seek, play, etc).
 */
export class TimeInvariantBase extends TimeAwareBase {
    async _propagateBuffering(_bufferingMode: BufferingMode) {}

    _propagatePlay() {}

    override _propagatePause() {}

    override get canPlay(): boolean {
        return true;
    }

    _emitAssetsCanPlay() {}

    /**
     * Is always true because this object does not contain any assets.
     */
    override get isDoneTryingToLoad(): boolean {
        return true;
    }

    /**
     * Is always true because this object does not contain any assets.
     */
    override get isLoaded(): boolean {
        return true;
    }
}
